import { Box, Paper } from "@mui/material";
import { COLORS } from "../constants";

interface ColorPickerProps {
  currentColor: string | null;
  onColorChange: (color: string | null) => void;
  onClose: () => void;
  popupAbove: boolean;
  colors?: (string | null)[];
}

export default function ColorPicker({
  currentColor,
  onColorChange,
  onClose,
  popupAbove,
  colors,
}: ColorPickerProps) {
  const palette = colors ?? COLORS;

  return (
    <Paper
      elevation={4}
      sx={{
        position: "absolute",
        ...(popupAbove
          ? { bottom: "100%", mb: 1 }
          : { top: "100%", mt: 1 }),
        left: "50%",
        transform: "translateX(-50%)",
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        gap: 0.5,
        p: 1,
        borderRadius: "12px",
        backgroundColor: "#fff",
        zIndex: 10,
        maxWidth: 200,
      }}
      onClick={(e) => e.stopPropagation()}
    >
      {palette.map((color, idx) =>
        color === null ? (
          <Box
            key={`no-fill-${idx}`}
            sx={{
              width: 24,
              height: 24,
              borderRadius: "50%",
              cursor: "pointer",
              border:
                currentColor === null
                  ? "2px solid #1976d2"
                  : "1px solid #ccc",
              position: "relative",
              overflow: "hidden",
              backgroundColor: "#fff",
              transition: "transform 0.1s",
              "&:hover": { transform: "scale(1.2)" },
            }}
            onClick={() => {
              onColorChange(null);
              onClose();
            }}
          >
            {/* Diagonal line for "no color" */}
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "-10%",
                width: "120%",
                height: "2px",
                backgroundColor: "#F44336",
                transform: "rotate(-45deg)",
                transformOrigin: "center",
              }}
            />
          </Box>
        ) : (
          <Box
            key={color}
            sx={{
              width: 24,
              height: 24,
              backgroundColor: color,
              borderRadius: "50%",
              cursor: "pointer",
              border:
                currentColor === color
                  ? "2px solid #1976d2"
                  : color === "#FFFFFF"
                  ? "1px solid #ccc"
                  : "1px solid transparent",
              transition: "transform 0.1s",
              "&:hover": { transform: "scale(1.2)" },
            }}
            onClick={() => {
              onColorChange(color);
              onClose();
            }}
          />
        )
      )}
    </Paper>
  );
}
